(ns app.front.view.admin.commands.delete-orphaned-registrations
  (:require [app.front.ui :as ui]
            [app.front.util :as futil]
            [app.front.view.group.admin.common :as acommon]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::group-id
  :-> ::group-id)

(rf/reg-sub ::modal-data
  :-> ::modal-data)

(rf/reg-event-db ::set-group-id
  (fn [db [_ group-id]]
    (assoc db ::group-id group-id)))

(rf/reg-event-fx ::precheck-success
  (fn [{:keys [db]} [_ _ {:keys [licences registrations] :as data}]]
    (if (and (= licences 0)
             (= registrations 0))
      {:dispatch [:notifications/add :toast :error :failure "The group has no orphaned licences or registrations"]}
      {:db (assoc db ::modal-data data)})))

(rf/reg-event-fx ::execute-precheck
  (fn [_ [_ group-id]]
    {:comm/command {:command    :admin/get-orphaned-l-and-cr
                    :method     :post
                    :data       {:group/id group-id}
                    :on-success [::precheck-success]}}))

(rf/reg-event-fx ::execute
  (fn [_ [_ group-id]]
    {:comm/command {:command    :admin/delete-orphaned-l-and-cr
                    :method     :post
                    :data       {:group/id group-id}
                    :on-success [::execution-success]}}))

(rf/reg-event-fx ::execution-success
  (fn [_ _]
    {:dispatch-n [[::clear-modal]
                  [:notifications/add :toast :success :success "Deletion was successful"]]}))

(rf/reg-event-db ::clear-modal
  (fn [db _]
    (dissoc db ::modal-data)))

(defn view [match]
  [acommon/admin-page-v2
   (util/mmap {:title "Delete orphaned licences and registrations"}
              match)
   (let [group-id (<sub [::group-id])]
     [:div
      (let [{:keys [licences registrations] :as modal-data} (<sub [::modal-data])]
        [cc/modal
         {:open                  (some? modal-data)
          :primary-button-text   "Delete"
          :secondary-button-text "Cancel"
          :modal-heading         "Delete licences or contractor registrations"
          :danger                true
          :on-request-close      #(>evt [::clear-modal])
          :on-request-submit     #(>evt [::execute group-id])}
         (cond
           (= licences 0)
           (str "Are you sure you want to delete " registrations " contractor registrations?")

           (= registrations 0)
           (str "Are you sure you want to delete " licences " licences?")

           :else
           (str "Are you sure you want to delete " licences " licences and " registrations " contractor registrations?"))])
      [:section
       [:div.flex.items-end
        [ui/text-input {:id          "group-id"
                        :light       true
                        :value       (<sub [::group-id])
                        :on-change   #(rf/dispatch-sync [::set-group-id (futil/tval %)])
                        :placeholder "CA-3539033-L"
                        :label-text  "Group ID (including permit type)"}]
        (cc/button {:kind     :primary
                    :disabled (str/blank? group-id)
                    :size     :field
                    :on-click #(>evt [::execute-precheck group-id])}
                   "Delete licences/registrations")]]])])

(def route
  {:name        :view/admin.commands.delete-orphaned-registrations
   :own-layout? true
   :view        view})
